import React, { useMemo, useState } from 'react';
import { DataType, MemberItem } from '@fx-ui/jdy-design-biz';
import {
    ContactValuePanel,
    getContactDeptList,
    MemberSelectDialog,
    getContactMemberList
} from '@fx-ui/platform-sdk';
import { useStores } from '~/hooks';
import { makeArray } from '@libs/shared';

interface MemberFieldUserProps {
    className?: string;
    style?: React.CSSProperties;
    value?: MemberItem | MemberItem[] | null | undefined;
    onChange?: (value: MemberItem | MemberItem[] | null | undefined) => void;
    multiple?: boolean;
    autoPop?: boolean;
    disabled?: boolean;
    onClose?: () => void;
}

const MemberFieldUser: React.FC<MemberFieldUserProps> = (props) => {
    const {
        className,
        style,
        value,
        onChange,
        multiple = true,
        autoPop = false,
        disabled,
        onClose
    } = props;

    const [visible, setVisible] = useState(autoPop);

    const { corpUserStore } = useStores();

    const fixValue = useMemo(() => makeArray(value), [value]);

    const handleClose = () => {
        setVisible(false);
        onClose?.();
    };

    return (
        <>
            <ContactValuePanel
                style={multiple ? style : { ...style, height: '42px' }}
                disabled={disabled}
                className={className}
                dataType={DataType.member}
                items={fixValue}
                onClick={() => setVisible(true)}
            />
            {!disabled && (
                <MemberSelectDialog
                    multiple={multiple}
                    visible={visible}
                    value={fixValue}
                    onFetchInternalDepartments={() => getContactDeptList(corpUserStore.tenantId)}
                    onFetchInternalMembers={(p) => {
                        return getContactMemberList(corpUserStore.tenantId, {
                            ...p,
                            hasCount: true
                        });
                    }}
                    onCancel={handleClose}
                    onOk={(members) => {
                        if (multiple) {
                            onChange?.(members ?? []);
                        } else {
                            onChange?.(members?.[0] ?? null);
                        }
                        handleClose();
                    }}
                />
            )}
        </>
    );
};

export default MemberFieldUser;
